import { BaseResponse } from '../manager/handle_data/HandleData';
import { PaginationRequest } from '../types';
import apiService from './api.service';

export interface ShareLinkDataType {
  id: number;
  data?: {
    link?: string;
    title?: string;
    description?: string;
  };
  parentType: 'SHARE_LINK';
}

export type ShareLinkUpsertType = Partial<ShareLinkDataType>;

class ShareLinkService {
  async getAll(params?: PaginationRequest): Promise<BaseResponse<ShareLinkDataType[]>> {
    const paramsReq = {
      parentType: 'SHARE_LINK',
      ...params,
    };
    const res = await apiService.get('b/sys-config', { params: paramsReq });
    const data = res?.data?.data || [];
    return data;
  }

  async getById(id: string): Promise<BaseResponse<ShareLinkDataType>> {
    const res = await apiService.get(`/b/sys-config/${id}`);
    return res.data;
  }

  async create(data: ShareLinkUpsertType): Promise<BaseResponse<ShareLinkDataType>> {
    const params = {
      parentType: 'SHARE_LINK',
      ...data,
    };
    const res = await apiService.post('/b/sys-config', params);
    return res.data;
  }

  async update({ id, data }: { id: number; data: ShareLinkUpsertType }): Promise<BaseResponse<ShareLinkDataType>> {
    const params = {
      parentType: 'SHARE_LINK',
      ...data,
    };
    const res = await apiService.put(`/b/sys-config/${id}`, params);
    return res.data;
  }

  async delete(id: number): Promise<BaseResponse<ShareLinkDataType>> {
    const res = await apiService.delete(`/b/sys-config/${id}`);
    return res.data;
  }
}

const sharelinkService = new ShareLinkService();
export default sharelinkService;
